import axios from 'axios'
import { Toast } from 'mint-ui'
import { removeToken, getToken, getUserValidCount, saveUserValidCount } from '@/utils/storage'
import { isMiniprogram } from '@/utils/environment'
import userStore from '../store/modules/user'
import getDeviceId from './device-id'
import { Dialog } from 'vant'
import { API } from '@/service/apiConfig'
import { generateSignature } from './util'
// import BASE_CONFIG from 'BASE_CONFIG'  自定义全局请求路径，暂时弃用，不要删除
// 创建axios实例
const service = axios.create({
  baseURL: '/', // api 的 base_url
  timeout: 600000 // 请求超时时间
})

// 全局错误统一错误提醒
function errorToast(msg) {
  Toast({
    message: msg,
    duration: 5000
  })
}

// todo @all 新老版本接口返回格式有所不一致，暂时这么处理，后续需要和服务端协商统一返回。
function handleSuccess(url, data) {
  if (
    url.indexOf('qxs-api/') > -1
    || url.indexOf('/mall') > -1
    || url.indexOf('/182-mall') > -1
    || url.indexOf('/33-mall') > -1
    || url.indexOf('knowledge-mall/') > -1
    || [API.selfBuildFaceMatch, API.selfBuildNoAuthMatch, API.selfBuildFaceVideoVerify, API.selfBuildNoAuthVideoVerify].includes(url)
  ) {
    return data
  }
  return data.data
}

function toLogin(validCount = 3) {
  removeToken()
  // 退出登录或者token过期清空uid
  if (window.__bl) {
    window.__bl.setConfig({
      uid: ''
    })
  }

  // 判断是否是云智用户
  const isYunZhiUser = localStorage.getItem('entry_point') === 'yunzhi'

  let redirect = ''
  if (window.location.pathname.indexOf('transfer') < 0 && window.location.pathname.indexOf('login') < 0) {
    redirect = encodeURIComponent(window.location.pathname + window.location.search)
  }
  if (userStore.getters.userType() === 'thirdUser') {
    window.location.href = `${window.location.origin}/transfer?source=1`
    return Promise.reject({ message: '用户状态异常，请返回公众号重新进入' })
  }
  isMiniprogram((env, wx) => {
    if (env) {
      wx.miniProgram.reLaunch({ url: '/pages/transfer/transfer?action=removeToken' })
    } else {
      if (validCount >= 3) {
        saveUserValidCount(0)
        // 根据用户类型跳转到不同登录页
        const loginPath = isYunZhiUser ? '/yunzhi-login' : '/login'
        window.location.href = `${window.location.origin}${loginPath}`
      } else {
        saveUserValidCount(validCount)
        window.location.href = `${window.location.origin}/transfer?redirect=${redirect}`
      }
    }
  })
}

function handleError(error, response = {}) {
  const { data, status, message } = response
  const code = data ? data.code : ''
  if (status === 401 || status === 403 || code === 401 || code === 403 || code === 20101002) {
    let validCount = getUserValidCount() || 0
    validCount++
    toLogin(validCount)
    const errorText = validCount >= 3 ? '登录失效，请重新登录' : '正在授权中'
    return Promise.reject({
      code: code,
      message: errorText
    })
  } else if (code === 20044) {
    Dialog.confirm({
      message: data && data.message ? data.message : '该学术任务不属于当前用户，请切换账号',
      confirmButtonText: '切换账号',
      cancelButtonText: '取消'
    })
      .then(() => {
        toLogin()
      })
      .catch(() => {
      })
  } else if (code) {
    return Promise.reject({
      code: code,
      data: data.data,
      message: data.message
    })
  } else if (message) {
    errorToast(`接口请求异常，可能是网络问题引起的，请稍后刷新页面或重新进入: ${message}`)
    return Promise.reject({
      code: status,
      message: message
    })
  }
  return Promise.reject(error)
}

// request拦截器
service.interceptors.request.use(
  config => {
    const token = getToken() || ''
    config.headers['token'] = token
    if (token) {
      const tokenParts = token.split('_')
      if (tokenParts.length >= 2) {
        config.headers.uid = tokenParts[1]
      }
    }
    config.params = {
      ...config.params,
      _t: new Date().getTime()
    }
    config.headers.deviceId = getDeviceId()

    // 生成签名
    const signature = generateSignature(
      config.params || {},
      config.data || {},
      navigator.userAgent
    )
    config.headers.signature = signature

    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// response 拦截器
// status 错误统一全局处理
// code码 错误，统一在在action的reject中处理（promise的第二个then）
service.interceptors.response.use(
  response => {
    const res = response.data
    const { code } = res
    if (code === 0) {
      return handleSuccess(response.config.url, res)
    }
    return handleError(undefined, response)

  }, error => {
    return handleError(error, error.response)
  }
)
export function checkToken() {
  if (!getToken()) {
    toLogin()
    return false
  }
  return true
}

export default service
